import { LOCALES, type Locale, type StaffLocale } from '@rental/domain'
import { de } from './messages/de'
import { en } from './messages/en'
import { it } from './messages/it'
import type { Messages } from './messages/types'
import { en as staffEn } from './staff/en'
import { it as staffIt } from './staff/it'
import type { StaffMessages } from './staff/types'
import { de as websiteDe } from './website/de'
import { en as websiteEn } from './website/en'
import { it as websiteIt } from './website/it'
import type { WebsiteMessages } from './website/types'

export { formatEuro, LOCALES, type Locale } from '@rental/domain'
export { COUNTRY_CODES, countryOptions } from './countries'
export {
  API_ERROR_CODES,
  type ApiErrorCode,
  isApiErrorCode,
  PUBLIC_ERROR_CODES,
  type PublicErrorCode,
  STAFF_ERROR_CODES,
  type StaffErrorCode,
} from './errors'
export {
  countryName,
  format,
  formatDate,
  formatDateTime,
  formatDayMonth,
  formatMonth,
  formatTime,
  INTL_LOCALE,
  localized,
  type Params,
  type PluralForms,
  placeholders,
  plural,
} from './format'
export { BOOKING_PATHS } from './paths'
export {
  confirmations,
  PRIVACY_NOTICE,
  type PrivacyBlock,
  type PrivacyItem,
  type PrivacyNotice,
  type PrivacySection,
} from './website/privacy'
export type { Messages, StaffMessages, WebsiteMessages }

export const MESSAGES: Readonly<Record<Locale, Messages>> = { it, en, de }

export function messagesFor(locale: Locale): Messages {
  return MESSAGES[locale]
}

/** The public website's own copy; never passed to the booking flow. */
export const WEBSITE_MESSAGES: Readonly<Record<Locale, WebsiteMessages>> = {
  it: websiteIt,
  en: websiteEn,
  de: websiteDe,
}

export function websiteMessagesFor(locale: Locale): WebsiteMessages {
  return WEBSITE_MESSAGES[locale]
}

/** The staff app's copy: Italian and English only (PRD). */
export const STAFF_MESSAGES: Readonly<Record<StaffLocale, StaffMessages>> = {
  it: staffIt,
  en: staffEn,
}

export function staffMessagesFor(locale: StaffLocale): StaffMessages {
  return STAFF_MESSAGES[locale]
}

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value)
}
